'use strict';

import React from 'react';
import ReactDOM from 'react-dom';
import {SelectTwoHtml} from "../selecttwohtml";


export {Steptwo};

class Steptwo extends React.Component {
    constructor(props) {
        super(props);
        this.state = { invalid: [], buyTelemart: false, idProduct: this.props.product ? this.props.product.id_product : 0};

        this.pc = [414];
        this.ledtop = [17];
    }

    componentDidUpdate(prevProps){
        const errors = document.querySelector('.help-block-error');
        if(errors){
            //errors.parentNode.scrollIntoView();
        }

    }

    setBuyTelemart(){
        const buy = this.state.buyTelemart;
        this.setState({buyTelemart: !buy});
    }
    validate(callback){
        let invalid = [];
        if(this.pc.includes(this.props.idCategory)){
            if(!document.getElementById('tiConfiguration').value){
                invalid.push('configuration');
            }
        }else if(this.ledtop.includes(this.props.idCategory)){
            if(!document.getElementById('tiConfiguration').value){
                invalid.push('configuration');
            }
            if(!document.querySelector('input[name="class"]:checked')){
                invalid.push('class');
            }
            if(!document.querySelector('input[name="package"]:checked')){
                invalid.push('package');
            }
            if(!document.querySelector('input[name="ncharge"]:checked')){
                invalid.push('ncharge');
            }
        }else{
            if(document.getElementById('tiIdProduct').value){

            }else{
                if(!document.getElementById('tiModel').value){
                    invalid.push('model');
                }
                if(!document.getElementById('tiBrand').value){
                    invalid.push('brand');
                }
            }


            if(!document.querySelector('input[name="class"]:checked')){
                invalid.push('class');
            }
            if(!document.querySelector('input[name="package"]:checked')){
                invalid.push('package');
            }
        }

        if(!invalid.length && typeof callback != 'undefined'){
            callback();
        }else{

        }
        this.setState({invalid: invalid});

    }
    render() {
        let data = [];
        let children  = "";
        if(this.props.product.name){
            children = '<option value="'+this.props.idProduct+'">' + this.props.product.name + '</option>';
            //data.push({id: this.props.idProduct, text: this.props.product.name, html: this.props.product.name});
        }
        console.log(this.props.idProduct);
        return (
            <div className={!this.props.active ? 'd-none' : ''}>
            <div className="trade-in-box__mid-form">
                <If condition={!this.pc.includes(this.props.idCategory) && !this.ledtop.includes(this.props.idCategory)}>
                    <div className="row trade-in-box__mid-form__row">
                        <div className="col-md-6">
                            <div className="select-box form-floating">
                                <input type="hidden" id="idCategory" name="id_category" value={this.props.idCategory}/>
                                <SelectTwoHtml
                                    name="id_product"
                                    id="tiIdProduct"
                                    data={data}
                                    value={this.props.idProduct}
                                    placeholder={lajax.t('Товар')}
                                    id_category={this.props.idCategory}
                                    allowClear={true}
                                    minimumInputLength={2}
                                    onChange={(name, value) => {this.props.setStateValue('idProduct', value); }}
                                    ajax={{
                                        url: baseUrl + 'category/ajax/',
                                        dataType: 'json',
                                        delay: 250,
                                        data: function (term, page) {
                                            return {
                                                term: term.term,
                                                id_category: $('#idCategory').val(),
                                                type: 1
                                            };
                                        },
                                        processResults: function (data) {
                                            return {
                                                results: data.items,
                                                total: data.total
                                            };
                                        },
                                        results: function (data, page) {
                                            var more = (page * 10) < data.total;
                                            return {
                                                results: data.items,
                                                more: more
                                            };
                                        }}}
                                >{children}</SelectTwoHtml>
                            </div>
                        </div>

                    </div>
                    <div className="row trade-in-box__mid-form__row">
                        <div className="col-md-6">{lajax.t('Или заполните вручную')}:</div>
                    </div>
                    <div className="row trade-in-box__mid-form__row">
                        <div className="col-md-6">
                            <div className={"form-floating" + (this.state.invalid.indexOf('brand') != -1 ? ' has-error' : '')}>
                                <input className="form-control" id="tiBrand" name="brand" type="text" placeholder={lajax.t('Бренд')} onChange={() => this.validate()}
                                    disabled={this.props.idProduct}/>
                                <label htmlFor="tiBrand">{lajax.t('Бренд')}</label>
                                <If condition={this.state.invalid.indexOf('brand') != -1}>
                                    <p className="help-block help-block-error">{lajax.t('Это обязательное поле')}</p>
                                </If>
                                {/*
                                    <div className="search-dropdown">
                                        <ul className="search-dropdown__list">
                                            <li className="search-dropdown__item"><a href="">Lenovo</a></li>
                                            <li className="search-dropdown__item"><a href="">LG</a></li>
                                            <li className="search-dropdown__item"><a href="">Lato</a></li>
                                        </ul>
                                    </div>
                                 */}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className={"form-floating" + (this.state.invalid.indexOf('model') != -1 ? ' has-error' : '')}>
                                <input className="form-control" id="tiModel" name="model" type="text" placeholder={lajax.t('Модель или p/n товара')}  onChange={() => this.validate()}
                                       disabled={this.props.idProduct}
                                />
                                <label htmlFor="tiModel">{lajax.t('Модель или p/n товара')}</label>
                                <If condition={this.state.invalid.indexOf('model') != -1}>
                                    <p className="help-block help-block-error">{lajax.t('Это обязательное поле')}</p>
                                </If>
                            </div>
                            <div className="trade-in-box__mid-form__helper">{lajax.t('Как найти модель или p/n устройства')}
                                <div className="button-tooltip" data-bs-toggle="popover" data-bs-trigger="hover focus click"
                                     data-bs-content={lajax.t("Как найти модель подсказка")}>
                                    <a className="button-tooltip__btn" target="_blank" href={baseUrl + "content/how-to-know-model.html"}>?</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="trade-in-box__mid-form__subtitle">{lajax.t('Состояние')}</div>
                    <div className="trade-in-box__state-list">
                        {this.props.classes.map((clas) => (
                            <div className="trade-in-box__state-list__item">
                                <input type="radio" id={"tiState" + clas.id} name="class" value={clas.id} onChange={() => this.validate()}/>
                                <label htmlFor={"tiState" + clas.id}><span>{clas.name}</span> {clas.description}</label>
                            </div>
                        ))}
                        <If condition={this.state.invalid.indexOf('class') != -1}>
                            <p className="help-block help-block-error">{lajax.t('Выберите класс')}</p>
                        </If>
                    </div>

                    <div className="trade-in-box__mid-form__subtitle">{lajax.t('Упаковка товара')}</div>
                    <div className="trade-in-box__line-options">
                        {this.props.packages.filter((packag) => this.props.idCategory != 301 || packag.id == 8).map((packag) => (
                            <div className="trade-in-box__line-options__item">
                                <input type="radio" id={"tiPack" + packag.id} name="package" value={packag.id} onChange={() => this.validate()}/>
                                    <label htmlFor={"tiPack" + packag.id}>{packag.description}</label>
                            </div>
                        ))}
                        <If condition={this.state.invalid.indexOf('package') != -1}>
                            <div className="line-break"></div>
                            <p className="help-block help-block-error">{lajax.t('Выберите упаковку')}</p>
                        </If>
                    </div>
                    <div className="trade-in-box__mid-form__subtitle">{lajax.t('Гарантия')}</div>
                    <div className="trade-in-box__line-options">
                        {this.props.warranties.map((warranty) => (
                            <div className="trade-in-box__line-options__item">
                                <input type="radio" id={"tiGuar" + warranty.id} name="warranty" value={warranty.id}/>
                                    <label htmlFor={"tiGuar" + warranty.id}>{warranty.description}</label>
                            </div>
                        ))}
                    </div>
                    <div className="trade-in-box__description">
                        <div className="form-floating">
                            <textarea className="form-control" id="tiDescription" name="description" rows="5" placeholder={lajax.t('Опишите состояние товара')}></textarea>
                            <label htmlFor="tiDescription">{lajax.t('Опишите состояние товара')}</label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="trade-in-box__buy-in">
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" id="tiBuyIn" name="buyintelemart" onChange={() => this.setBuyTelemart()}/>
                                    <label className="form-check-label" htmlFor="tiBuyIn">{lajax.t('Покупал(а) в Telemart')}</label>
                                </div>
                            </div>
                        </div>
                        <If condition={this.state.buyTelemart}>
                        <div className="col-md-6">
                            <div className="trade-in-box__buy-in">
                                <div className={"form-floating"}>
                                    <input className="form-control" id="tiOrder" name="id_order" type="text" placeholder={lajax.t('Номер заказа')}/>
                                    <label htmlFor="tiModel">{lajax.t('Номер заказа')}</label>
                                </div>
                            </div>
                        </div>
                        </If>
                    </div>
                </If>

                <If condition={this.ledtop.includes(this.props.idCategory)}>
                    <div className="trade-in-box__mid-form__subtitle">{lajax.t('Я подтверждаю, что мой ноутбук исправен и загружается ОС Windows.')}</div>
                    <div className="trade-in-box__configuration">
                        <div className="form-floating">
                            <textarea className="form-control" id="tiConfiguration" name="configuration" rows="5"
                                      placeholder="Конфигурация"></textarea>
                            <label htmlFor="tiConfiguration">{lajax.t('Конфигурация')}</label>
                        </div>
                        <div className="trade-in-box__mid-form__helper">{lajax.t('Как определить конфигурацию компьютера с помощью')} <a style={{textDecoration: "revert", color: "#a2c617"}} href="https://telemart.ua/hwi.zip" target="_blank">HWiNFO Diagnostic Software</a>
                            <div className="button-tooltip" data-bs-toggle="popover" data-bs-trigger="hover focus click"
                                 data-bs-content={lajax.t('Этот товар будет совместим с вашим если чтото произойдет или ты что-то сделаешь')}>&nbsp;
                                <a className="button-tooltip__btn" target="_blank" href={baseUrl + "content/how-to-know-pc-configuration.html"}>?</a>
                            </div>
                        </div>
                        <If condition={this.state.invalid.indexOf('configuration') != -1}>
                            <p className="help-block help-block-error">{lajax.t('Это обязательное поле')}</p>
                        </If>
                    </div>

                    <div className="trade-in-box__mid-form__subtitle">{lajax.t('Состояние')}</div>
                    <div className="trade-in-box__state-list">
                        {this.props.classes.map((clas) => (
                            <div className="trade-in-box__state-list__item">
                                <input type="radio" id={"tiState" + clas.id} name="class" value={clas.id} onChange={() => this.validate()}/>
                                <label htmlFor={"tiState" + clas.id}><span>{clas.name}</span> {clas.description}</label>
                            </div>
                        ))}
                        <If condition={this.state.invalid.indexOf('class') != -1}>
                            <p className="help-block help-block-error">{lajax.t('Выберите класс')}</p>
                        </If>
                    </div>

                    <div className="trade-in-box__mid-form__subtitle">{lajax.t('Упаковка товара')}</div>
                    <div className="trade-in-box__line-options">
                        {this.props.packages.map((packag) => (
                            <div className="trade-in-box__line-options__item">
                                <input type="radio" id={"tiPack" + packag.id} name="package" value={packag.id} onChange={() => this.validate()}/>
                                <label htmlFor={"tiPack" + packag.id}>{packag.description}</label>
                            </div>
                        ))}
                        <If condition={this.state.invalid.indexOf('package') != -1}>
                            <div className="line-break"></div>
                            <p className="help-block help-block-error">{lajax.t('Выберите упаковку')}</p>
                        </If>
                    </div>
                    <div className="trade-in-box__mid-form__subtitle">{lajax.t('Зарядное устройство')}</div>
                    <div className="trade-in-box__line-options">
                        <div className="trade-in-box__line-options__item">
                            <input type="radio" id="npackage8" name="ncharge" value="1" onChange={() => this.validate()}/>
                            <label htmlFor="npackage8">{lajax.t('Есть')}</label>
                        </div>
                        <div className="trade-in-box__line-options__item">
                            <input type="radio" id="npackage10" name="ncharge" value="0" onChange={() => this.validate()}/>
                            <label htmlFor="npackage10">{lajax.t('Нет')}</label>
                        </div>
                        <If condition={this.state.invalid.indexOf('ncharge') != -1}>
                            <div className="line-break"></div>
                            <p className="help-block help-block-error">{lajax.t('Выберите есть ли зарядное')}</p>
                        </If>
                    </div>
                    <div className="trade-in-box__mid-form__subtitle">{lajax.t('Гарантия')}</div>
                    <div className="trade-in-box__line-options">
                        {this.props.warranties.map((warranty) => (
                            <div className="trade-in-box__line-options__item">
                                <input type="radio" id={"tiGuar" + warranty.id} name="warranty" value={warranty.id}/>
                                <label htmlFor={"tiGuar" + warranty.id}>{warranty.description}</label>
                            </div>
                        ))}
                    </div>
                    <div className="trade-in-box__description">
                        <div className="form-floating">
                            <textarea className="form-control" id="tiDescription" name="defect" rows="5" placeholder={lajax.t('Опишите состояние товара')}></textarea>
                            <label htmlFor="tiDescription">{lajax.t('Опишите состояние товара')}</label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="trade-in-box__buy-in">
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" id="tiBuyIn" name="buyintelemart" onChange={() => this.setBuyTelemart()}/>
                                    <label className="form-check-label" htmlFor="tiBuyIn">{lajax.t('Покупал(а) в Telemart')}</label>
                                </div>
                            </div>
                        </div>
                        <If condition={this.state.buyTelemart}>
                            <div className="col-md-6">
                                <div className="trade-in-box__buy-in">
                                    <div className={"form-floating"}>
                                        <input className="form-control" id="tiOrder" name="id_order" type="text" placeholder={lajax.t('Номер заказа')}/>
                                        <label htmlFor="tiModel">{lajax.t('Номер заказа')}</label>
                                    </div>
                                </div>
                            </div>
                        </If>
                    </div>
                </If>
                <If condition={this.pc.includes(this.props.idCategory)}>
                    <div className="trade-in-box__configuration">
                        <div className="trade-in-box__mid-form__subtitle">{lajax.t('Я подтверждаю, что мой ПК исправен и загружается ОС Windows.')}</div>
                        <div className="form-floating">
                            <textarea className="form-control" id="tiConfiguration" name="configuration" rows="5"
                                      placeholder="{lajax.t('Конфигурация ноутука')}"></textarea>
                            <label htmlFor="tiConfiguration">{lajax.t('Конфигурация')}</label>
                        </div>
                        <div className="trade-in-box__mid-form__helper">{lajax.t('Как определить конфигурацию компьютера с помощью')} <a style={{textDecoration: "revert", color: "#a2c617"}} href="https://telemart.ua/hwi.zip" target="_blank">HWiNFO Diagnostic Software</a>
                            <div className="button-tooltip" data-bs-toggle="popover" data-bs-trigger="hover focus click"
                                 data-bs-content={lajax.t('Этот товар будет совместим с вашим если чтото произойдет или ты что-то сделаешь')}>&nbsp;
                                <a className="button-tooltip__btn" target="_blank" href={baseUrl + "content/how-to-know-pc-configuration.html"}>?</a>
                            </div>
                        </div>
                        <If condition={this.state.invalid.indexOf('configuration') != -1}>
                            <p className="help-block help-block-error">{lajax.t('Это обязательное поле')}</p>
                        </If>
                    </div>
                    <div className="trade-in-box__model-body">
                        <div className="form-floating">
                            <input className="form-control" id="tiBodyModel" type="text" name="case" placeholder={lajax.t('Модель корпуса')}/>
                                <label htmlFor="tiBodyModel">{lajax.t('Модель корпуса')}</label>
                        </div>
                        <div className="trade-in-box__mid-form__helper">{lajax.t('Как найти модель корпуса')}
                            <div className="button-tooltip" data-bs-toggle="popover" data-bs-trigger="hover focus click" data-bs-content={lajax.t('Этот товар будет совместим с вашим если чтото произойдет или ты что-то сделаешь')}>
                                <button className="button-tooltip__btn" type="button">?</button>
                            </div>
                        </div>
                    </div>
                    <div className="trade-in-box__buy-in">
                        <div className="form-check">
                            <input className="form-check-input" type="checkbox" id="tiBox" name="casebox"/>
                            <label className="form-check-label" htmlFor="tiBox">{lajax.t('Есть коробка от корпуса')}</label>
                        </div>
                    </div>
                </If>
            </div>
        <button className="btn btn-lg btn-primary" type="button" onClick={() => this.validate(() => this.props.setStep(3))}>{lajax.t('Ввести контактные данные')}</button>
       </div>);

    }
}
